import { ApiProperty } from '@nestjs/swagger';
export class SpecSheetFileUploadDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
    @ApiProperty()
    specSheetId: number;
}